import React from 'react';
import { useSearchParams, useNavigate } from 'react-router'; // react-router-dom v6+
import { Link } from 'react-router';

const PaymentSuccess = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const trxID = searchParams.get('trxID');

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
            <div className="bg-white p-8 rounded-2xl shadow-xl max-w-md w-full text-center border border-gray-100">
                
                {/* Success Icon Animation */}
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6 animate-bounce">
                    <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path>
                    </svg>
                </div>

                <h1 className="text-3xl font-extrabold text-gray-900 mb-2">Payment Successful!</h1>
                <p className="text-gray-500 mb-8">Thank you for your subscription. Your account has been upgraded successfully.</p>

                {/* Receipt Card */}
                <div className="bg-gray-50 rounded-xl p-6 mb-8 text-left border border-gray-200">
                    <div className="flex justify-between mb-3">
                        <span className="text-gray-500 text-sm">Payment Method</span>
                        <span className="font-bold text-gray-800">bKash</span>
                    </div>
                    <div className="flex justify-between mb-3">
                        <span className="text-gray-500 text-sm">Transaction ID</span>
                        <span className="font-mono font-bold text-indigo-600 bg-indigo-50 px-2 py-0.5 rounded text-sm">
                            {trxID || 'N/A'}
                        </span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-gray-500 text-sm">Status</span>
                        <span className="text-green-600 font-bold text-sm flex items-center gap-1">
                            ● Completed
                        </span>
                    </div>
                </div>

                {/* Actions */}
                <div className="space-y-3">
                    <button 
                        onClick={() => navigate('/dashboard')}
                        className="w-full bg-indigo-600 text-white font-bold py-3.5 rounded-xl hover:bg-indigo-700 transition shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                    >
                        Go to Dashboard
                    </button>
                    
                    <Link to="/profile" className="block text-indigo-600 font-semibold text-sm hover:underline">
                        View Billing History
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccess;